<template>

  <el-form :model="form" :rules="rules" ref="form">

    <el-form-item label="Nome Fantasia" prop="nomeFantasia">
      <el-input v-model="form.nomeFantasia"></el-input>
    </el-form-item>

    <el-form-item 
      v-for="(razaoSocial, index) in form.razoesSociais"
      :label="'Razão Social - ' + (index+1) + 'ª Opção'"
      :key="razaoSocial.key"
      :prop="'razoesSociais.' + index + '.nome'"
      :rules="{ required: true, message: 'A razão social da empresa é obrigatório', trigger: 'blur'}"
    >
      <el-button type="danger" size="mini" @click="removeName(razaoSocial)" icon="delete" v-if="form.razoesSociais.length > 1">Deletar</el-button>
      <el-input v-model="razaoSocial.nome"></el-input>
    </el-form-item>

    <el-form-item>
      <el-button type="success" @click="addName">Adicionar Razão Social</el-button>
    </el-form-item>

  </el-form>

</template>

<script>
export default {
  props: ['form'],

  data () {
    return {
      rules: {
        nomeFantasia: [
          { required: true, message: 'O nome fantasia da empresa é obrigatório', trigger: 'blur' }
        ]
      }
    }
  },

  methods: {
    removeName (item) {
      this.form.razoesSociais.splice(this.form.razoesSociais.indexOf(item), 1)
    },

    addName () {
      this.form.razoesSociais.push({
        key: Date.now(),
        nome: ''
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// PessoaJuridica.vue?56f0079c